import { SET_CURRENT_VITALS } from './vitals.type'

export const setCurrentVital = (data) => async (dispatch) => {
    dispatch({
        type: SET_CURRENT_VITALS,
        payload: data,
    })
}
